import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import EventBus from '../event-bus.js';

import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';

import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

export default defineComponent({
    name: 'split-panes',
    mixins: [BaseComponent],
    components: {
        Splitpanes,
        Pane,
    },
    data: function () {
        return {
        }
    },
    created() {
        for (let i = 0; i < this.controlData.Panes.length; i++) {
            const p = this.controlData.Panes[i];
            if (p.DisplayExpression)
                p.displayexpr = utils.compileExpression(this, p.DisplayExpression);
        }
    },
    //Created Replaced with preRenderComplete
    computed: {
        totalItems() {
            let count = 1;
            if (this.controlData.Panes && Array.isArray(this.controlData.Panes))
                for (let p of this.controlData.Panes)
                    count += p.Controls.length;

            return count;
        },
        storageKey: function () {
            //if (this.persistencekeyexpn) {
            //    const key = utils.evaluate(this.persistencekeyexpn, this);
            //    return `splitpanes-${this.parentType}-${key || this.controlData.Name || 'unnamed'}-${this.controlData.$objectid || 'noid'}`;
            //}
            //else
                return `splitpanes-${this.parentType}-${this.controlData.Name || 'unnamed'}-${this.controlData.$objectid || 'noid'}`;
        },
    },
    methods: {
        async preRenderComplete() {
            this.finishRenderHandler(this);
        },
        paneResized(e) {
            if (this.controlData.PersistSizes) {
                const key = `${this.storageKey}_${e.index}_size`;
                this.System.LocalStorage(key, e.prevPane.size);
            }
        },
        initialPaneSize(index) {
            if (this.controlData.PersistSizes) {
                let key = `${this.storageKey}_${index}_size`;
                let value = this.System.LocalStorage(key);
                if (!value && index > 0) {
                    key = `${this.storageKey}_${index - 1}_size`;
                    value = this.System.LocalStorage(key);
                    if (value)
                        return 100 - value;
                }
            }
        },
    },
    render() {
        if(!this.todisplay)
            return null;
        
        try {
            const panes = [];

            for (let i = 0; i < this.controlData.Panes.length; i++) {
                const p = this.controlData.Panes[i];
                if (p.displayexpr && !utils.evaluate(p.displayexpr, this))
                    continue;

                let paneStyle;
                if (p.FlexBoxContent || p.FlexBoxContent === undefined)
                    paneStyle = {
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: '1',
                        height: '100px',
                    };

                let items = [];
                p.Controls.forEach((c, index) => {
                    if (!(typeof c === 'object'))
                        return;

                    let DynamicControl = utils.getDynamicComponent(h, c);

                    if (!DynamicControl)
                        DynamicControl = 'default-unknown';

                    if (!c.$objectId) c.$objectId = utils.generateUUID();

                    let id = c.$objectId;
                    if (index) id += '_' + index;

                    items.push(
                        <DynamicControl
                            onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                            key={id}
                            type={c.ControlType}
                            name={c.ControlData.Name ? c.ControlData.Name : ''}
                            root={this.root}
                            parentType="VerticalLayout"
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            sourceIndex={index}
                            sourceData={null}
                            controlName={c.Name}
                            scopeitems={this.scopeitems}
                            controlscope={this.controlscope}
                            cacheControl={c.CacheControl}
                            controlEvents={c.Events}
                        >
                        </DynamicControl>
                    );
                });

                panes.push(
                    <Pane
                        style="display: flex; flex-direction: column; overflow: auto;"
                        key={i}
                        size={this.initialPaneSize(i) ?? p.InitialSize}
                        xmin-size={p.MinSize}
                        xmax-size={p.MaxSize}
                        dbl-click-splitter={p.AllowDoubleClick}
                    >
                        <div style={paneStyle}>
                            {items}
                        </div>
                    </Pane>
                );
                    // {utils.generateItemsFromArray(h, this, p.Controls, null, "VerticalLayout")}
            }

            const style = {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
            //    display: "flex",
            //    flexDirection: "column",
            //    overflow: "auto",
            };

            return (
                <Splitpanes
                    v-show={this.isvisible}
                    style={style}
                    class={{ 'default-theme': true, 'c-SplitPanes': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                    horizontal={this.controlData.Orientation == 'Horizontal'}
                    push-other-panes={this.controlData.EnablePushAdjacent}
                    first-splitter={this.controlData.ShowFirstSplitter}
                    onResized={(e) => this.paneResized(e)}
                    >
                    {panes}
                </Splitpanes>
            );
        }
        catch (e) {
            utils.error('SplitPanes Render failed', e);
            return <div>SplitPanes Failed to Render {e}</div>;
        }
    }
});